package de.ohhhmhhh.backend.models.model.text

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertStaticTextRevisionRequest(
    @SerialName("id")
    val id: String,
    @SerialName("title")
    val title: String,
    @SerialName("content")
    val content: String
)
